<template>
  <BlocksCard class="listing-view-buyers-checklist">
    <h2 class="__heading __underlined">
      Buyers Checklist
    </h2>
    <ul v-if="content.checklist" class="__check-list">
      <li v-for="(item, key) in content.checklist" :key="`checklist-item-${key}`">
        <nuxt-link v-if="item.url" :to="item.url" :target="isExternal(item.url) ? '_blank' : '_self'">
          {{ item.label }}
        </nuxt-link>
        <span v-else>
          {{ item.label }}
        </span>
      </li>
    </ul>
  </BlocksCard>
</template>

<script setup lang="ts">
import {useFetch, useRuntimeConfig} from '#app';
import globalApiHeaders from '~/composables/globalApiHeaders';
import triggerSiteDownError from '~/composables/triggerSiteDownError';
import {ApiReturn} from '~/@types/common';
import {Ref} from 'vue';

// DATA Definitions
//----------------------------------------------------------------------------------------------------------------------
const config = useRuntimeConfig();
const content: Ref<object | null> = ref(null);

// DATA Fetching
//----------------------------------------------------------------------------------------------------------------------
const {data} = await useFetch(() => '/public/cms/show/buyers-checklist', { baseURL: config.public.apiUrl, headers: globalApiHeaders() });
if (!data.value || (data.value as ApiReturn).code !== 200 || !(data.value as ApiReturn).data) {
  triggerSiteDownError();
} else {
  content.value = (data.value as ApiReturn).data.content;
}

/**
 * Check if link is external
 *
 * @param link
 */
function isExternal(link: string | null) {
if (!link) {
    return false;
  }
  return link.startsWith('http://') || link.startsWith('https://');
}
</script>

<style lang="scss">
.listing-view-buyers-checklist {
  .__check-list {
    a {
      text-decoration: none;
      color: rgb(var(--text-dark));
      transition: color 0.2s;

      &:hover {
        color: rgb(var(--accent));
        transition: color 0.2s;
      }
    }
  }
}
</style>
